import React, { Component } from 'react';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';
import { runtime } from 'rest/runtime';
import moment from 'moment-timezone';

class RowView extends Component {
  timeConverter(UNIX_timestamp){
    var a = new Date(UNIX_timestamp*1000);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = (''+a.getHours()).length > 1 ? a.getHours() : '0'+a.getHours();
    var min = (''+a.getMinutes()).length > 1 ? a.getMinutes() : '0'+a.getMinutes();
    var sec = (''+a.getSeconds()).length > 1 ? a.getSeconds() : '0'+a.getSeconds();
    return date + ', ' + month + ' ' + year + ' - ' + hour + ':' + min + ':' + sec ;
  }

  getUserTimeformat() {
    if (runtime.currentUser.get('timeformat') == 12) {
        return 'D. MMM YYYY, h:mm:ss A';
    }

    return 'D. MMM YYYY, H:mm:ss';
  }

  render() {
    const activity = this.props.activity;
    const time = moment(activity.crdate, 'X').format(this.getUserTimeformat());
    const name = activity.name;
    const message = activity.message;

    return (
      <TableRow>
        <TableColumn>{time}</TableColumn>
        <TableColumn>{name}</TableColumn>
        <TableColumn>{message}</TableColumn>
      </TableRow>
    );
  }
}

export default RowView;
